var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileTextLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 14,
    viewBox: "0 0 101 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.764648 13.5871V0.375H5.38889L7.6727 11.8884H8.01244L10.2962 0.375H14.9205V13.5871H12.5046V2.20582H12.1648L9.89989 13.5871H5.78525L3.52032 2.20582H3.18058V13.5871H0.764648Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4574 13.5871V0.375H26.9509V2.63993H20.9488V5.79197H26.4224V8.0569H20.9488V11.3222H27.0642V13.5871H18.4574Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0146 13.5871V2.63993H29.1642V0.375H39.3565V2.63993H35.5061V13.5871H33.0146Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9792 13.5871L43.4521 0.375H47.7932L51.2661 13.5871H48.6992L47.9819 10.6805H43.2633L42.5461 13.5871H39.9792ZM43.8484 8.37777H47.3968L45.7925 1.94158H45.4528L43.8484 8.37777Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8962 13.5871V0.375H56.3876V11.3222H62.4274V13.5871H53.8962Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1745 13.5871V0.375H73.668V2.63993H67.666V5.79197H73.1396V8.0569H67.666V11.3222H73.7813V13.5871H65.1745Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6741 13.5871V0.375H81.4116L84.0351 11.8884H84.3749V0.375H86.8286V13.5871H82.0911L79.4675 2.0737H79.1278V13.5871H76.6741Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3671 13.5871V0.375H94.897C96.6712 0.375 98.0175 0.827987 98.9361 1.73396C99.8672 2.62735 100.333 3.96115 100.333 5.73535V8.22677C100.333 10.001 99.8672 11.3411 98.9361 12.247C98.0175 13.1404 96.6712 13.5871 94.897 13.5871H90.3671ZM92.8585 11.3222H94.9347C95.9414 11.3222 96.6775 11.0579 97.143 10.5295C97.6086 10.001 97.8414 9.25858 97.8414 8.30227V5.65985C97.8414 4.69096 97.6086 3.94856 97.143 3.43266C96.6775 2.90418 95.9414 2.63993 94.9347 2.63993H92.8585V11.3222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTextLogo);
export default __webpack_public_path__ + "static/media/mobile-text-logo.afa18b99139fe4c3384c90be0f047129.svg";
export { ForwardRef as ReactComponent };